up.compiler('[additional-items-restriction]', (element, { maxServices, additional_item_name }) => {
  if (element.closest('[no-edit]')) return

  const observer = new MutationObserver(disableOrEnableAdditionalItems)

  function disableOrEnableAdditionalItems() {
    const addItemButton = element.querySelector('[additional-item-button]')
    const activeItems = element.querySelectorAll('[delete-additional-item-button] input[value="false"]')

    const serviceTemplates = Array.from(element.querySelectorAll('[additional-service-template]'))
    const checkedServiceTemplates = serviceTemplates.filter((t) => t.checked)
    const uncheckedServiceTemplates = serviceTemplates.filter((t) => !t.checked)
    const uncheckedLabels = uncheckedServiceTemplates.map((el) => el.parentElement)

    const disable = (activeItems.length + checkedServiceTemplates.length) >= maxServices

    if (addItemButton) {
      addItemButton.toggleAttribute('disabled', disable)

      if (disable) {
        addItemButton.setAttribute('title', `Maximal ${maxServices} ${additional_item_name} möglich`)
        uncheckedLabels.forEach(
          (el) => el.setAttribute('title', `Maximal ${maxServices} ${additional_item_name} möglich`)
        )
      } else {
        addItemButton.removeAttribute('title')
        uncheckedLabels.forEach((el) => el.removeAttribute('title'))
      }
    }

    uncheckedServiceTemplates.forEach((el) => el.toggleAttribute('disabled', disable))
  }

  disableOrEnableAdditionalItems()
  observer.observe(element, { subtree: true, childList: true, attributeFilter: ['hidden'] })

  return () => {
    observer.disconnect()
  }
})
